"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnderwayRequest = void 0;
var UnderwayRequest = /** @class */ (function () {
    function UnderwayRequest() {
    }
    return UnderwayRequest;
}());
exports.UnderwayRequest = UnderwayRequest;
;
//# sourceMappingURL=underway.request.js.map